// extracted by mini-css-extract-plugin
export default {"home":"Home_home__7zvDl","loader":"Home_loader__jCMiV","row":"Home_row__pGgxK"};